import ReactSelect, { createFilter, GroupBase } from 'react-select';

import classNames from 'classnames';

import { Group, GroupHeading, MultiValue, Option, useIsFixed } from 'components/select/shared';
import { SelectProps } from 'types/components/select';

import cssClasses from './select.module.scss';

function Select<
  IsMulti extends boolean = false,
  Option = unknown,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ className, isFixed, maxVisible, ...props }: SelectProps<IsMulti, Option, Group>) {
  const { components } = props;
  const { changed, clearable } = useIsFixed<IsMulti, Option, Group>({ isFixed, ...props });

  return (
    <ReactSelect
      {...props}
      className={classNames(cssClasses.select, className)}
      classNamePrefix="select"
      components={{
        Group,
        GroupHeading,
        MultiValue,
        Option,
        ...components,
      }}
      filterOption={createFilter({ ignoreAccents: false })}
      isClearable={clearable}
      isFixed={isFixed}
      maxVisible={maxVisible}
      menuPlacement="auto"
      menuShouldScrollIntoView
      onChange={changed}
    />
  );
}

export default Select;
